import React from "react";
import "./Profile.css";

export default function Profile() {
  return (
  <div id= "wrapper">
    <h1 className="not-found">sorry, page not found. please return to homepage.</h1>
    <div class="clearer"></div>
</div>

  );
}